import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobNoteQueryKeys } from '@/modules/candidates/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UpdateCandidateJobNoteRequestBody = ApiRequestBody<
  typeof candidateEndpoints.candidateJobNote,
  'put'
>;

type UpdateCandidateJobNoteParams = {
  candidateJobId: string;
  noteId: string;
  body: UpdateCandidateJobNoteRequestBody;
};

export const useUpdateCandidateJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({
      candidateJobId,
      noteId,
      body,
    }: UpdateCandidateJobNoteParams) => {
      const { data } = await fetchClient.PUT(
        candidateEndpoints.candidateJobNote,
        {
          params: { path: { candidateJobId, noteId } },
          body,
        },
      );

      return data;
    },
    onSettled: (_data, _error, { candidateJobId }) => {
      invalidateQuery(candidateJobNoteQueryKeys.list(candidateJobId))();
    },
  });
};
